import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ScheduleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"schedule"}/>
}
